export function parse(input) {
  return input.value || input.textContent;
}